import React, { useEffect } from 'react';
import clsx from 'clsx';
import { ModalProps } from './types';
import { styles, sizeStyles } from './styles';
import { Button } from '../Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size = 'md',
  variant = 'default',
}) => {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className={clsx(
        styles.overlay,
        variant === 'side' ? styles.overlaySide : styles.overlayCenter
      )}
      onClick={handleOverlayClick}
    >
      <div
        className={clsx(
          styles.container,
          variant === 'side' ? styles.containerSide : styles.containerDefault,
          sizeStyles[size]
        )}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClose}
            aria-label="Close modal"
            icon={<FontAwesomeIcon icon={faTimes} className={styles.closeButton} />}
          />
        </div>

        <div
          className={clsx(
            styles.body,
            variant === 'side' ? styles.bodySide : styles.bodyDefault
          )}
        >
          {children}
        </div>

        {footer && <div className={styles.footer}>{footer}</div>}
      </div>
    </div>
  );
};

export type { ModalProps } from './types';
export default Modal;
